<template>
  <div class="chat-wrapper">
    <div class="chat-preload" role="status" v-if="loading === true">
      <span class="sr-only">Cargando...</span>
    </div>
    <div class="chat-content" v-else>
      <p class="chat-title">Deja tu mensaje:</p>
      <div class="main-chat-container">
        <div class="messages-content" :style="{ visibility: !chathidden ? 'visible' : 'hidden' }">
          <div class="message-wrapper">
            <div class="message-content" v-for="(message, index) in messages" :key="message.id">
              <p :class="message.username === 'samsung' ? 'admin-msg' : ''" v-if="message.visible">
                <b>{{ message.username }}:</b>{{ message.text }}
              </p>
            </div>
          </div>
        </div>
        <div class="featured-msg-container">
          <div class="message-content featured-msg" v-for="(pinned) in pinnedMsg">
            <p class="mb-0 text-light"><b>{{ pinned.username }}:</b>{{ pinned.text }}</p>
            <div class="ml-3">
              <i class="fa fa-thumb-tack" aria-hidden="true"></i>
            </div>
          </div>
        </div>
        <div class="post-content">
          <div class="box-post" v-if="!name">

            <div class="icon-input">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">
                <path
                  d="M8 8C6.9 8 5.95833 7.60833 5.175 6.825C4.39167 6.04167 4 5.1 4 4C4 2.9 4.39167 1.95833 5.175 1.175C5.95833 0.391667 6.9 0 8 0C9.1 0 10.0417 0.391667 10.825 1.175C11.6083 1.95833 12 2.9 12 4C12 5.1 11.6083 6.04167 10.825 6.825C10.0417 7.60833 9.1 8 8 8ZM0 16V13.2C0 12.6333 0.145833 12.1125 0.4375 11.6375C0.729167 11.1625 1.11667 10.8 1.6 10.55C2.63333 10.0333 3.68333 9.64583 4.75 9.3875C5.81667 9.12917 6.9 9 8 9C9.1 9 10.1833 9.12917 11.25 9.3875C12.3167 9.64583 13.3667 10.0333 14.4 10.55C14.8833 10.8 15.2708 11.1625 15.5625 11.6375C15.8542 12.1125 16 12.6333 16 13.2V16H0Z"
                  fill="currentColor" />
              </svg>
            </div>

            <input class="form-control-sm enter-input" type="text" v-model="userName" placeholder="Ingresa tu nombre"
              @keyup="nombreUsado = false" :maxlength="maxUserNameChar + 5" @click="handleBlur"
              @focusout="handleFocusout" :style="{ visibility: !chathidden ? 'visible' : 'hidden' }" />
            <button class="enter-btn" @click="updateUsername"
              :style="{ visibility: !chathidden ? 'visible' : 'hidden' }"
              :disabled="userName.length >= maxUserNameChar">
              Entrar
              <i class="fa fa-sign-in ml-1" aria-hidden="true"></i>
            </button>

            <div class="alerta" v-if="nombreUsado === true && userName.length > 0">
              El usuario <strong>"{{ userName }}"</strong> ya está en uso, escoja otro nombre.
            </div>

            <div class="alerta" v-if="userName.length >= maxUserNameChar">
              El usuario <strong>"{{ userName }}"</strong> es muy largo, prueba otro.
            </div>

          </div>
          <div class="box-post" v-if="name">
            <input class="form-control-sm input-chat" :maxlength="maxMessageChar + 5" v-model="mensaje"
              placeholder="Ingresa tu mensaje" :disabled="!name" @click="handleBlur" @focusout="handleFocusout"
              :style="{ visibility: !chathidden ? 'visible' : 'hidden' }">
            <button class="btn enviar" @click="enviarMensaje" :disabled="!name || mensaje.length >= maxMessageChar"
              :style="{ visibility: !chathidden ? 'visible' : 'hidden' }">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                <path fill="none" d="M0 0h24v24H0z" />
                <path
                  d="M3 13h6v-2H3V1.846a.5.5 0 0 1 .741-.438l18.462 10.154a.5.5 0 0 1 0 .876L3.741 22.592A.5.5 0 0 1 3 22.154V13z"
                  fill="rgba(255,255,255,1)" />
              </svg>
            </button>
            <div v-if="spam === true" class="alerta">
              No se pudo enviar el mensaje.
            </div>

            <div class="alerta" v-if="mensaje.length >= maxMessageChar">
              Mensaje demasiado largo, prueba otro.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import fire from '../fire';

export default {
  name: "Chat",
  props: {
    origen: Boolean
  },
  data() {
    return {
      userName: "",
      nombreUsado: false,
      name: null,
      mensaje: "",
      messages: [],
      loading: true,
      limit: 300,
      enviados: [],
      spam: false,
      grocerias: [],
      chathidden: false,
      banned: [],
      enableKeyboard: false,
      pinnedMsg: [],
      maxUserNameChar: 15,
      maxMessageChar: 300
    };
  },
  methods: {
    hidechat() {
      this.chathidden = !this.chathidden
      this.$emit('chathidden', this.chathidden)
    },
    updateUsername() {
      this.nombreUsado = false;
      if (this.userName.length >= this.maxUserNameChar) {
        alert('nombre muy largo, prueba otro');
        this.userName = '';
        return;
      }
      if (this.userName.length > 0) {
        if (this.userName.toLowerCase().includes("samsung") && !this.origen) {
          alert("No puedes usar el nombre samsung");
          this.userName = null;
        }
        else {
          let regExpSource = this.grocerias.join("|");
          let regExpFilter = new RegExp(regExpSource, "ig");
          this.userName = this.userName.replace(regExpFilter, function () {
            return "*!@*#*";
          });
          fire
            .database()
            .ref("messages")
            .orderByChild("username")
            .equalTo(this.userName.toLowerCase())
            .once("value", snapshot => {
              if (snapshot.exists()) {
                if (this.userName.toLowerCase() == "samsungliveshop23" && this.origen) {
                  this.name = 'samsung';
                  sessionStorage.setItem("userName", 'samsung');
                  this.nombreUsado = false;
                } else {
                  this.nombreUsado = true;
                }
              } else {
                if (this.userName.toLowerCase() == "samsungliveshop23" && this.origen) {
                  this.name = 'samsung';
                  sessionStorage.setItem("userName", 'samsung');
                  this.nombreUsado = false;
                } else {
                  this.name = this.userName;
                  sessionStorage.setItem("userName", this.userName.toLowerCase());
                  this.nombreUsado = false;
                }
              }
            });
        }
      } else {
        this.nombreUsado = false;
      }
    },
    enviarMensaje() {
      if (this.mensaje.length >= this.maxMessageChar) {
        alert('mensaje muy largo, prueba otro');
        this.mensaje = '';
        return;
      }
      if (this.mensaje.length > 0) {
        this.spam = false;
        let regExpSource = this.grocerias.join("|");
        let regExpFilter = new RegExp(regExpSource, "ig");
        let textoFiltrado = this.mensaje.replace(regExpFilter, function () {
          return "*!@*#*";
        });
        //Shorten the message
        if (textoFiltrado.length > 350) {
          textoFiltrado = textoFiltrado.substr(0, this.limit) + "...";
        }
        if (!this.checkSpam(textoFiltrado) && !this.banned.includes(this.name.toLowerCase())) {
          const message = {
            text: textoFiltrado,
            username: this.name.toLowerCase(),
            fecha: Date.now(),
            visible: true,
          };
          fire
            .database()
            .ref("messages")
            .push(message);
          this.mensaje = "";
          this.scrollBottom();
        } else {
          this.spam = true;
        }
      }
    },
    scrollBottom() {
      const chatWindow = document.getElementById("mensajes");
      if (chatWindow) {
        let xH = chatWindow.scrollHeight;
        xH = xH + 150;
        chatWindow.scrollTo(0, xH);
      }
      //document.getElementById("fin").scrollIntoView(true);
    },
    checkSpam(message) {
      const countOccurrences = (arr, val) =>
        arr.reduce((a, v) => (v === val ? a + 1 : a), 0);

      if (this.enviados.length > 0) {
        let veces = countOccurrences(this.enviados, message);
        if (veces > 1) {
          return true;
        } else {
          this.enviados.push(message);
          sessionStorage.setItem("messages", JSON.stringify(this.enviados));
          return false;
        }
      } else {
        this.enviados.push(message);
        sessionStorage.setItem("messages", JSON.stringify(this.enviados));
        return false;
      }
    },
    cargaGroserias() {
      const itemsRef = fire.database().ref("palabras");
      this.loading = false;
      itemsRef.on("value", snapshot => {
        let data = snapshot.val();
        let palabrotas = [];
        Object.keys(data).forEach(key => {
          palabrotas.push(data[key].palabra);
        });
        this.grocerias = palabrotas;
      });
    },
    cargaMensajes() {
      let viewMessage = this;
      const itemsRef = fire
        .database()
        .ref("messages")
        .limitToLast(30);
      this.loading = false;
      itemsRef.on("value", snapshot => {
        let data = snapshot.val();
        let messages = [];
        Object.keys(data).forEach(key => {
          //delay chat
          setInterval(
            messages.push({
              id: key,
              username: data[key].username,
              text: data[key].text,
              fecha: data[key].fecha,
              visible: data[key].visible,
            })
            , 200);
        });
        viewMessage.messages = messages;
        setTimeout(() => this.scrollToBottom(), 100)

      });
    },
    loadPinnedMsg() {
      const pinnedMsg = fire.database().ref('messages');
      // .once solo recibe una ves la data en cambio .on la recibe en tiempo real
      pinnedMsg.on('value', (snapshot) => {
        const data = snapshot.val()
        if (data) {
          //  Here i can assign the data whit the object id included
          const filteredPinnedMsg = Object.keys(data)
            .filter(id => data[id].pinned === true)
            .map(id => ({ id, ...data[id] }))
          this.pinnedMsg = filteredPinnedMsg
        }
      })
    },
    cargaUsuarios() {
      const itemsRef = fire.database().ref("banned");
      itemsRef.on("value", snapshot => {
        let data = snapshot.val();
        let banned = [];
        Object.keys(data).forEach(key => {
          banned.push(data[key].username.toLowerCase());
        });
        this.banned = banned;
      });
    },
    keyboardCheck() {
      console.log('focused')
    },
    handleBlur(e) {
      document.querySelector('.box-post').classList.add('keyboard')
    },
    handleFocusout(e) {
      document.querySelector('.box-post').classList.remove('keyboard')
    },
    scrollToBottom() {
      const containerTest = document.querySelector('.message-wrapper');
      if (containerTest) {
        containerTest.scrollTop = containerTest.scrollHeight;
      } else {
        console.log('not')
      }
    },
  },
  mounted() {
    this.loadPinnedMsg();
    this.cargaMensajes();
    this.cargaUsuarios();
    setTimeout(() => this.scrollBottom(), 3000);
    setInterval(this.scrollBottom, 500);
    let usuario = sessionStorage.getItem("userName");
    if (usuario) {
      this.userName = usuario;
      this.name = usuario;
    }
    //se pone texto en español
    this.$moment.locale("es");

    //reviso el historial de mensajes
    if (sessionStorage.getItem("messages")) {
      this.enviados = JSON.parse(sessionStorage.getItem("messages"));
    }
    //cargo las palabras prohibidas
    this.cargaGroserias();
    window.scrollTo(0, 0)
  },


  created() {

  },
  watch: {
    enableKeyboard: function () {
      console.log('cambio')
    }
  }
};
</script>

<style lang="scss" scooped>
.main-chat-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}

.alerta {
  position: absolute;
  bottom: -15px;
  font-size: 12px;
  color: red;
  margin-left: 8px;
  font-weight: 700;

  @media (max-width: 300px) {
    font-size: 8px;
  }
}

.chat-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 10px;
  padding-bottom: 15px;

  @media only screen and (max-width: 701px) {
    height: 250px;
    padding: 0px;
    padding-bottom: 10px;
  }

  .chat-content {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: flex-end;

    .chat-title {
      position: relative;
      font-weight: 800;
      color: #000;
      margin: 0;
      height: 50px;
      display: flex;
      align-items: center;

      @media only screen and (max-width: 701px) {
        display: none;
      }
    }

    .messages-content {
      position: relative;
      height: 100%;
      overflow: hidden;
      -webkit-mask-image: linear-gradient(to bottom, transparent, rgba(255, 255, 255, .8), rgba(255, 255, 255, 1), rgba(255, 255, 255, 1));
      mask-image: linear-gradient(to bottom, transparent, rgba(255, 255, 255, .8), rgba(255, 255, 255, 1), rgba(255, 255, 255, 1));

      @media only screen and (max-width: 701px) {
        background-color: #FFF;
        max-height: 203px;
        height: 100%;
        margin: 0 5px;
      }

      .message-wrapper {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        flex-direction: column;

        @media only screen and (max-width: 701px) {
          overflow-y: scroll;
          height: 100%;
        }

        .message-content {
          position: relative;
          width: 85%;
          display: flex;
          margin-left: 5px;

          &:first-child {
            margin-top: auto !important;
          }


          @media only screen and (max-width: 701px) {
            width: 75%;
          }

          .admin-msg {
            padding: 0 5px;
            background-color: #218AFF;
            color: #FFF;
            padding: 3px 8px;
            border-radius: 10px;
            margin-left: -5px;
          }

          p {
            position: relative;
            font-size: 13px;
            line-height: 17px;
            color: #000;
            margin: 0;
            margin-bottom: 5px;

            b {
              text-transform: capitalize;
              margin-right: 10px;
            }
          }
        }
      }
    }

    .post-content {
      position: relative;
      width: 100%;
      height: 50px;
      background-color: #FFF;

      .box-post {
        position: relative;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #FFF;

        .icon-input {
          position: absolute;
          top: 50%;
          left: 15px;
          transform: translateY(-50%);
          width: 20px;
          height: auto;
          color: #747474;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .enter-input {
          padding-left: 32px;
          transition: .15s all linear;

          &::placeholder {
            color: #747474 !important;
          }

          &:focus {
            border: 2px solid #218AFF !important;
            outline: none;
            transition: .15s all linear;
          }
        }

        .hidechat {
          position: relative;
          width: 25px;
          height: 25px;
          margin: 0 10px;
        }

        input {
          font-size: 12px;
          width: 100%;
          display: inline-block;
          background-color: #FFF;
          border: 1px solid #000;
          border-radius: 15px;
          color: #000;
          padding: 10px;
          margin-left: 5px;
        }

        .enter-btn {
          background-color: #000;
          color: #fff;
          padding: 5px 10px;
          margin: 5px 10px;
          font-weight: 700;
          text-align: center;
          font-size: 12px;
          border-radius: 20px;
          border: 1px solid #000;
          display: flex;
          align-items: center;
          width: fit-content;
          transition: all .15s linear;

          &[disabled] {
            background-color: #a8a8a8;
            border: 1px solid #a8a8a8;

          }
        }



        button {
          font-size: 12px;
          width: 60px;
          font-weight: bold;
          float: right;
          background-color: #FFF;
          color: #000;
          border-radius: 20px;
          text-align: center;

          svg>path:nth-child(2) {
            fill: #000;
          }
        }
      }
    }
  }
}



.featured-msg-container {
  margin: 5px 0px 0px 0px;

  @media only screen and (max-width: 701px) {
    margin: 5px 10px 0px 10px;
  }

  .featured-msg {
    display: flex;
    justify-content: space-between;
    background-color: #218AFF;
    color: #fff !important;
    padding: 5px 12px;
    align-items: center;
    border-radius: 10px;
    margin-bottom: 5px;
    max-width: 410px;
    margin-right: 50px;

    /* @media only screen and (max-width: 701px) {
      width: 300px;
      padding: 2px 8px;
    }

    @media only screen and (max-width: 375.5px) {
      width: 270px;
      padding: 2px 8px;
    }

    @media only screen and (max-width: 320.5px) {
      width: 230px;
      padding: 2px 8px;
    }

    @media only screen and (max-width: 290.5px) {
      width: 190px;
    } */

    p {
      color: #fff !important;
      font-size: 12px;

      b {
        text-transform: capitalize;
        margin-right: 10px;
      }
    }
  }
}
</style>